<div class="risk-bar-graph"
  [ngClass]="{'risk-bar-graph--expand-modal': isModal}">
  <div class="risk-bar-graph__graph-container"
    [ngClass]="{'risk-bar-graph__graph-container--expand-modal': isModal}"
    [ngStyle]="{'height': this.riskBarGraph.height+'px'}"></div>
  <div class="risk-bar-graph__tooltip-container"
    [id]="'risk-bar-graph-tooltip-'+idGraph">
    <div class="risk-bar-graph__tooltip-block">
      <div class="risk-bar-graph__header-container">
        <p class="risk-bar-graph__header-title"
          [afTranslate]="'field-items.dependencies'">_dependencias</p>
        <button class="risk-bar-graph__header-icon">
          <i class="lf-icon-close"
            (click)="closeRiskTooltip()"></i>
        </button>
      </div>
      <div class="risk-bar-graph__subheader-container">
        <i class="lf-icon-step-final risk-bar-graph__subheader-icon"
          [ngStyle]="{'color':riskBarGraph.nodeSelected.color}"></i>
        <p class="risk-bar-graph__subheader-title">
          <span>{{riskBarGraph.nodeSelected?.typeRisk}}</span>
          <span>:&nbsp;</span>
          <span>{{riskBarGraph.nodeSelected?.label}}</span>
        </p>
      </div>
      <div class="donut-graph__tooltip-body-container">
        <ul class="donut-graph__tooltip-body-list donut-graph__tooltip-body-list--risk">
          <li *ngFor="let dependency of riskBarGraph.nodeSelected.dependencies"
            class="donut-graph__tooltip-body-item donut-graph__tooltip-body-item--risk">
            {{dependency}}
          </li>
        </ul>
      </div>
    </div>
  </div>
  
</div>
